var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fullName)?_c('el-tooltip',{attrs:{"content":_vm.fullName,"placement":"top","effect":"dark"}},[_c('span',{staticClass:"metabolite-label"},[_vm._v(_vm._s(_vm.value))])]):_c('span',[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }